// src/core/data/redux/slices/PowerDialerSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  session: null,
  currentContact: null,
  nextDialNumber: null,
  fromNumber: null,
  isActive: false,
  isPaused: false,
  campaignCompletedAt: null,
};

const powerDialerSlice = createSlice({
  name: "powerDialer",
  initialState,
  reducers: {
    setPowerDialerSession: (state, action) => {
      const { session, contact, fromNumber } = action.payload;
      state.session = session;
      state.currentContact = contact;
      if (fromNumber !== undefined) state.fromNumber = fromNumber ?? null;
      state.isActive = session?.status === "active";
      state.isPaused = session?.status === "paused";
    },
    setPowerDialerNextNumber: (state, action) => {
      state.nextDialNumber = action.payload;
    },
    clearPowerDialerNextNumber: (state) => {
      state.nextDialNumber = null;
    },
    setPowerDialerPaused: (state) => {
      if (state.session) state.session.status = "paused";
      state.isActive = false;
      state.isPaused = true;
    },
    setPowerDialerResumed: (state) => {
      if (state.session) state.session.status = "active";
      state.isActive = true;
      state.isPaused = false;
    },
    clearPowerDialerSession: (state) => {
      state.session = null;
      state.currentContact = null;
      state.nextDialNumber = null;
      state.fromNumber = null;
      state.isActive = false;
      state.isPaused = false;
    },
    markCampaignCompleted: (state) => {
      state.campaignCompletedAt = Date.now();
    },
    setFromNumber: (state, action) => {
      state.fromNumber = action.payload ?? null;
    },
  },
});

export const {
  setPowerDialerSession,
  setPowerDialerNextNumber,
  clearPowerDialerNextNumber,
  setPowerDialerPaused,
  setPowerDialerResumed,
  clearPowerDialerSession,
  markCampaignCompleted,
  setFromNumber,
} = powerDialerSlice.actions;

export default powerDialerSlice.reducer;
